var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tabbar", {
    attrs: { curIndex: _vm.curIndex, tabbarList: _vm.tabbarList },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }